import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Loader} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class ModelsDetail extends Component {
  componentDidMount() {
    this.props.getPartCarCompatibility(this.props.partCode);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.partCode !== this.props.partCode) {
      this.props.getPartCarCompatibility(this.props.partCode);
    }
  }

  renderModels() {
    const {models} = this.props;

    return models.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell>{element.model}</Table.Cell>
          <Table.Cell>{element.katashiki}</Table.Cell>
          <Table.Cell>{element.brand}</Table.Cell>
          <Table.Cell>{element.motor}</Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }

    return (
      <Table.Row>
        <Table.Cell className='lost-sales-models' colSpan='100%'>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Modelo</Table.HeaderCell>
                <Table.HeaderCell>Katashiki</Table.HeaderCell>
                <Table.HeaderCell>Marca</Table.HeaderCell>
                <Table.HeaderCell>Motor</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {this.renderModels()}
            </Table.Body>
          </Table>
        </Table.Cell>
      </Table.Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.partsMaster.loadingCompatibility,
    'models': state.partsMaster.compatibility,
  };
};

const {getPartCarCompatibility} = Actions;

export default connect(mapStateToProps, {getPartCarCompatibility})(ModelsDetail);
